import React from "react";
import SEO from "../../SEO";
import { useCanonicalUrl } from "../../useCanonicalUrl";

const ContactUs = () => {
  const canonical = useCanonicalUrl();
  return (
    <>
      <SEO
        title="Contact Us | Trust Doc"
        description="Get in touch with Trust Doc support team."
        canonical={canonical}
      />

      <div className="contact-page">
        {/* Header Section */}
        <header className="contact-header">
          <h1>Contact Us</h1>
          <p>
            We’d love to hear from you. Reach out for inquiries or support
            anytime.
          </p>
        </header>

        {/* Contact Card */}
        <section className="contact-card">
          <div className="contact-item">
            <h3>Email</h3>
            <p>
              <a href="mailto:support@trust-doc.com">support@trust-doc.com</a>
            </p>
          </div>

          <div className="contact-item">
            <h3>Phone</h3>
            <p>
              <a href="tel:+971505482370">+971 505 482 370</a>
            </p>
          </div>

          <div className="contact-item">
            <h3>Address</h3>
            <p>Dubai Silicon Oasis, DDP, Building A2, Dubai</p>
          </div>
        </section>

        {/* Style Section */}
        <style>{`
        .contact-page {
          min-height: 100vh;
          background: linear-gradient(to bottom right, #f0f9ff, #ffffff, #e0f2fe);
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-bottom: 4rem;
        }

        .contact-header {
          width: 100%;
          background-color: #0369a1; /* sky-700 */
          color: white;
          text-align: center;
          padding: 1rem;
          box-shadow: 0 4px 10px rgba(0,0,0,0.1);
        }

        .contact-header h1 {
          font-size: 2.5rem;
          font-weight: 800;
          margin-bottom: 1rem;
        }

        .contact-header p {
          max-width: 650px;
          margin: 0 auto;
          font-size: 1.1rem;
          font-weight: 300;
          opacity: 0.9;
        }

        .contact-card {
          max-width: 700px;
          background: white;
          margin-top: 3rem;
          padding: 2.5rem 3rem;
          border-radius: 1.2rem;
          box-shadow: 0 8px 20px rgba(0,0,0,0.08);
          border: 1px solid #f3f4f6;
          display: flex;
          flex-direction: column;
          gap: 1.8rem;
        }

        .contact-item h3 {
          font-size: 1.2rem;
          color: #0369a1;
          margin-bottom: 0.3rem;
        }

        .contact-item p {
          font-size: 1.05rem;
          color: #374151;
          margin: 0;
        }

        .contact-item a {
          text-decoration: none;
          color: #0369a1;
          font-weight: 500;
        }

        .contact-item a:hover {
          text-decoration: underline;
        }

        @media (max-width: 600px) {
          .contact-card {
            padding: 2rem;
          }

          .contact-header h1 {
            font-size: 2rem;
          }
        }
      `}</style>
      </div>
    </>
  );
};

export default ContactUs;
